import React, { useMemo } from 'react';
import { TbHeartPlus } from "react-icons/tb";
import { useIntl } from 'react-intl';
import { useAuth, useComposition, useModal } from '../../../context';
import FramiButton from '../../common/FramiButton';

const SaveForLaterButton = ({className}) => {
    const { currentComp, updateCompFavourite} = useComposition();
    const { galleryInfoAccepted, user } = useAuth();
    const { openModal } = useModal();
    const intl = useIntl();

    const disabled = false

    const title = useMemo(() => {
        if (!galleryInfoAccepted && !user) {
            return intl.formatMessage({ id: 'studio.button.save_for_later' });
        } else if (currentComp?.favourite) {
            return intl.formatMessage({ id: 'studio.button.remove_from_favourites' });
        } else {
            return intl.formatMessage({ id: 'studio.button.add_to_favourites' });
        }
    }, [currentComp?.favourite, galleryInfoAccepted, user]);

    const handleClick = async () => {
        if (!galleryInfoAccepted && !user) {
            openModal('saveForLater')
        } else if (currentComp?.favourite) {
            updateCompFavourite(false)
        } else {
            updateCompFavourite(true)
        }
    }

    return (
        <FramiButton
            className={`action-button uppercase`}
            style={{boxShadow: 'none'}}
            dataPh={'floating bottom add to cart'}
            leftIcon={<TbHeartPlus />}
            disabled={disabled}
            title={title}
            dataCy='save-for-later-button'
            onClick={handleClick}
        />
    );
};

export default SaveForLaterButton;
